import type {
  BackendModule,
  InitOptions,
  ReadCallback,
  Services,
} from 'i18next';

type Options = {
  endpoint?: string;
  fetchOptions?: RequestInit;
};

export class CustomRestBackend implements BackendModule<Options> {
  public static type = 'backend' as const;
  public type = CustomRestBackend.type;

  services!: Services;
  options: Options = {};
  i18nextOptions: InitOptions = {};
  endpoint = '/api/translations/translations/';
  fetchOptions: RequestInit = {};

  constructor(
    services?: Services,
    options: Options = {},
    i18nextOptions: InitOptions = {}
  ) {
    if (services || options || i18nextOptions)
      this.init(services, options, i18nextOptions);
  }

  init(
    services?: Services,
    options: Options = {},
    i18nextOptions: InitOptions = {}
  ) {
    if (services) this.services = services;
    this.options = options ?? {};
    this.i18nextOptions = i18nextOptions ?? {};

    this.endpoint = this.options.endpoint ?? this.endpoint;
    this.fetchOptions = this.options.fetchOptions ?? {};
  }

  async read(language: string, namespace: string, callback: ReadCallback) {
    try {
      const url = `${this.endpoint}${encodeURIComponent(language)}`;
      const res = await fetch(url, this.fetchOptions);
      if (!res.ok) {
        callback(
          new Error(`Failed to load translations: ${res.status}`),
          false
        );
        return;
      }
      const json = await res.json();

      // Endpoint shape nests translations under the language code:
      // { "fr-FR": { "menu": { ... } } }
      const langBlock = json[language] ?? {};
      const nsData = langBlock?.[namespace] ?? null;

      // If namespace not present, give empty object to let i18next fall back to key
      callback(null, nsData ?? {});
    } catch (err) {
      callback(err as Error, false);
    }
  }
}
